import { render, staticRenderFns } from "./FixOrderNow.vue?vue&type=template&id=221a5946&scoped=true"
import script from "./FixOrderNow.vue?vue&type=script&lang=js"
export * from "./FixOrderNow.vue?vue&type=script&lang=js"
import style0 from "./FixOrderNow.vue?vue&type=style&index=0&id=221a5946&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a5946",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221a5946')) {
      api.createRecord('221a5946', component.options)
    } else {
      api.reload('221a5946', component.options)
    }
    module.hot.accept("./FixOrderNow.vue?vue&type=template&id=221a5946&scoped=true", function () {
      api.rerender('221a5946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FixOrderNow.vue"
export default component.exports